import {styled} from "@mui/system";
import {DataGrid} from "@mui/x-data-grid";

export const StyledDataGrid = styled(DataGrid)`
  & .genehmigt {
    background-color: green;
    color: white;
  }

  & .pending {
    background-color: yellow;
    color: black;
  }

  & .abgelehnt {
    background-color: red;
    color: white;
  }

  & .status {
    align-self: center;
    text-align: center;
  }
`;